import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {UserCardResponse} from "../../interface/userCardResponse";
import {ImageType} from "../../enums/image-type-enum";
import {UserService} from "../../service/user.service";
import {UserCardService} from "../../service/user-card.service";
import {TelcellService} from "../../service/telcell.service";
import {IdramService} from "../../service/idram.service";
import {InitPaymentRequest} from "../../models/payment/initPaymentRequest";
import {InitPaymentResponse} from "../../models/payment/initPaymentResponse";
import {MobileDetectionService} from "../../service/mobile-detection.service";
import {CreditCardService} from "../../service/credit-card.service";
import {CreditCardResponse} from "../../models/creditCardResponse";
import {WalletToWalletPaymentReceipt} from "../../models/payment/walletToWalletPaymentReceipt";
import {MockupDataModel} from "../../qr-copy-message/mockup-data.model";
import {SnackBarUtil} from "../../qr-copy-message/snack-bar-util.service";
import {PaymentMethod} from "./payment-method.enum";
import {AmeriaWalletToWalletService} from "../../service/ameria-wallet-to-wallet.service";
import {MoneyLuxPaymentService} from "../../service/money-lux-payment.service";
import {MoneyLuxPaymentInfoRequest} from "../../models/moneyLuxPaymentInfoRequest";
import {AMERIA_FORM_APPLE_PAY, AMERIA_FORM_CREDIT_CARD, PAYMENT_ID_NAME} from "../../constants/payment.constant";
import {
  DEFAULT_COMMISSION,
  DUPLICATE_MONEY_LUX_UUID_MESSAGE, PAY_URL_COPY_SUCCESS_ALERT,
} from "../../constants/global.constants";
import {EasywalletService} from "../../service/easywallet.service";
import {PaymentQrCodeService} from "../../service/payment-qr-code-service";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {QrGenerateComponent} from "../../qr-generate/qr-generate.component";
import {PaymentQrCodeRequest} from "../../interface/paymentQrCodeRequest";
import {LinkUtils} from "../../utilityClass/linkUtils";
import {MyPayService} from "../../service/my-pay.service";

import {FastshiftService} from "../../service/fastshift.service";
import {COPIED_MASSAGE} from "../../subscription-payment/subscription-payment.constant";
import {TELCELL_PLACEHOLDER} from "../../constants/telcell-placeholder.constants";
import {TranslateService} from "@ngx-translate/core";
import {PaymentMethodConfigService} from "../../service/payment-method-config.service";
import {PaymentMethodConfig} from "../../models/payment-method-config.model";

@Component({
  selector: 'app-cards-by-qr-payment',
  templateUrl: './cards-by-qr-payment.component.html',
  styleUrls: ['../cards-by-qr.component.scss', '../cards-by-qr-media.component.scss', './cards-by-qr-payment.component.scss', '../../layouts/toggle/toggle.component.scss']
})
export class CardsByQrPaymentComponent implements OnInit {

  protected readonly PAY_PRODUCT: string = "Transfer money to a user with ID: ";
  protected readonly PAY_VALID_DAYS: number = 1;

  protected readonly ImageType = ImageType;

  paymentMethodConfigs: PaymentMethodConfig[] = [];

  isMobile: boolean = false;
  showError: boolean = false;
  saveError: boolean = false;
  userCard?: UserCardResponse;
  options: number[] = [500, 1000, 2500, 5000];
  selectedOption: number | null = null;
  inputValue: string = '';
  errorMessage?: string;
  companyLogoExists: boolean = false;
  isCommissionFeeActive: boolean = true;
  moneyLuxUuid: string | null = null;
  isInputReadOnly: boolean = false;

  protected creditCard?: CreditCardResponse;
  protected isPayClicked: boolean = false;

  @ViewChild("inputElement") priceInputElementRef!: ElementRef<HTMLInputElement>;

  constructor(
    private route: ActivatedRoute,
    private userCardService: UserCardService,
    private userService: UserService,
    private router: Router,
    private location: Location,
    private telcellService: TelcellService,
    private idram: IdramService,
    private creditCardService: CreditCardService,
    private snackBar: SnackBarUtil,
    private ameriaWalletToWalletService: AmeriaWalletToWalletService,
    private moneyLuxPaymentService: MoneyLuxPaymentService,
    private easywalletService: EasywalletService,
    private paymentQrCodeService: PaymentQrCodeService,
    private dialog: MatDialog,
    private linkUtils: LinkUtils,
    private myPayService: MyPayService,
    private fastshiftService: FastshiftService,
    private translateService: TranslateService,
    private paymentMethodConfigService: PaymentMethodConfigService
  ) {
  }

  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/']);
    }
  }

  get productWithUserCardId() {
    return this.PAY_PRODUCT + this.userCard?.cardId;
  }

  get getCreditCardLastNumbers() {
    return this.creditCard?.cardNumber;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.isMobile = (event.target as Window).innerWidth <= 768;
  }

  ngOnInit(): void {
    this.paymentMethodConfigService.getAll().subscribe({
      next: (configs) => this.paymentMethodConfigs = configs
    });
    this.isMobile = window.innerWidth <= 768;
    this.isMobile = MobileDetectionService.isMobile();
    this.route.params.subscribe(params => {
      const qrCode = params['qrCode'];
      const encodedUuid = params['uuid'];
      const encodedAmount = params['amount'];
      if (encodedAmount && encodedUuid && qrCode) {
        const amount = atob(encodedAmount);
        this.moneyLuxUuid = encodedUuid
        this.inputValue = amount
        const requestBody: MoneyLuxPaymentInfoRequest = {
          cardId: qrCode,
          moneyLuxUuid: encodedUuid,
          amount: encodedAmount
        };
        this.isCommissionFeeActive = false
        this.moneyLuxPaymentService.save(requestBody).subscribe()
      }
      if (!qrCode) {
        this.showError = true;
        return;
      }

      this.userCardService.getCardByQRCode(qrCode).subscribe({
          next: (response: UserCardResponse) => {
            this.userCard = response;
            const imageUrl = this.getUserCardImage(response.id, ImageType.COMPANY_LOGO);
            this.userCardService.checkImageExists(imageUrl).subscribe(exists => {
              this.companyLogoExists = exists;
            });
          },
          error: (err) => {
            if (err.status === 404) {
              this.router.navigate(['/error-page']);
            } else {
              this.showError = true;
            }
          }
        }
      );
      this.getParamsByPaymentQr();
    });
    this.initAllCreditCards();
  }

  getParamsByPaymentQr() {
    this.route.queryParams.subscribe(queryParams => {
      const amount = queryParams['amount'];
      const isCommissionActive = queryParams['isCommissionActive'];

      if (amount !== undefined) {
        this.inputValue = amount;
        this.isInputReadOnly = true;
      }

      if (isCommissionActive !== undefined) {
        this.isCommissionFeeActive = isCommissionActive === 'true';
      }
    });
  }

  redirectTelcellApp(value: string): void {
    navigator.clipboard.writeText(value).then(() => {
      this.showSnackbar(MockupDataModel.success(this.translateService.instant(COPIED_MASSAGE)), SnackBarUtil.CLASSES.success);
      window.open('https://qrtelcell.onelink.me/1hAx/sg625', '_blank');
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

  getUserCardImage(id: bigint, type: ImageType) {
    return this.userCardService.getCardImage(id, type);
  }

  onCreateProfile() {
    if (!this.userService.token) {
      this.router.navigate(['sign-up'])
    } else {
      this.router.navigate(['cards'])
    }
  }

  selectOption(option: number) {
    this.selectedOption = option;
    this.inputValue = String(option);
  }

  isSelected(option: number): boolean {
    return this.selectedOption === option;
  }

  onPriceInput(event: Event) {
    if (!this.userCard?.isBusiness) {
      this.hideMessageUnderPrice();
      const input = event.target as HTMLInputElement;
      const value = input.value.trim();
      const matchingOption = this.options.find(option => option.toString() === value);

      if (value !== '') {
        if (matchingOption) {
          this.selectOption(matchingOption);
        } else {
          this.selectedOption = null;
        }
      } else {
        this.selectedOption = null;
      }
    }
  }

  onKeyPress(event: KeyboardEvent) {
    if (!this.inputValue.length && event.key == "0") {
      event.preventDefault();
      return;
    }

    const allowedChars = /[^0-9]/g;
    const inputChar = String.fromCharCode(event.charCode);
    if (allowedChars.test(inputChar)) {
      event.preventDefault();
      return;
    }
  }

  private telcellOpenMobileApp(price: string) {
    this.telcellService.createNewAccount(price, this.userCard?.cardId!, this.isCommissionFeeActive, this.moneyLuxUuid).subscribe({
      next: (invoiceId: string) => {
        window.location.href = `https://telcellwallet.page.link/?link=https://com.telcell.app?actionType%3DinvoiceId%26actionValue%3D${invoiceId}&apn=ru.deltapay.puntopago.telcell&isi=1324511564&ibi=com.telcell.app`;
        this.isPayClicked = false;
      },
      error: (error) => {
        if (error.status === 511 && error.error && error.error.message) {
          this.showSnackbar(MockupDataModel.error(DUPLICATE_MONEY_LUX_UUID_MESSAGE), SnackBarUtil.CLASSES.error);
        } else {
          this.telcellOpenPageRequest(price);
        }
      }
    })
  }

  private telcellOpenPageRequest(price: string) {
    this.telcellService.initPayment(price, this.productWithUserCardId, String(this.PAY_VALID_DAYS), this.userCard!, this.isCommissionFeeActive, this.moneyLuxUuid);
    this.isPayClicked = false;
  }

  pay(paymentMethod: PaymentMethod) {
    if (this.inputValue.length == 0) {
      this.showErrorMessageUnderPriceFor5Seconds();
      this.priceInputElementRef.nativeElement.scrollIntoView({behavior: 'smooth', block: 'center'});
      return;
    }
    if (this.isPayClicked) return;
    this.isPayClicked = true;
    switch (paymentMethod) {
      case PaymentMethod.TELCELL:
        this.payWithTelcell();
        break;
      case PaymentMethod.NEW_CREDIT_CARD:
        this.payWithCard();
        break;
      case PaymentMethod.APPLE_PAY:
        this.payWithCard(true);
        break;
      case PaymentMethod.IDRAM:
        this.payWithIdram();
        break;
      case PaymentMethod.EASY_WALLET:
        this.payWithEasyWallet();
        break;
      case PaymentMethod.MY_PAY:
        this.payWithMyPay();
        break;
      case PaymentMethod.FASTSHIFT:
        this.payWithFastshift();
        break;
      case PaymentMethod.EXISTING_CREDIT_CARD:
        this.payWithExistingCreditCard()
    }
  }


  public payWithMyPay() {
    const price = this.inputValue;
    const isCommissionFeeActive = this.isCommissionFeeActive;
    this.myPayService.initPayment(price, this.userCard!, isCommissionFeeActive);
    this.isPayClicked = false;
  }

  public payWithIdram() {
    const price = this.inputValue;
    this.idram.initPayment(this.userCard!, price, this.productWithUserCardId, this.isCommissionFeeActive, this.moneyLuxUuid);
    this.isPayClicked = false;
  }

  public payWithCard(isApplePay: boolean = false) {
    const price = this.inputValue;
    const description: string = this.productWithUserCardId;
    const userId: bigint = this.userCard?.userId!;
    const request: InitPaymentRequest = InitPaymentRequest.initForWalletToWallet(description, Number(price), userId, this.userCard!.cardId, "", this.moneyLuxUuid);
    this.ameriaWalletToWalletService.init(request, this.isCommissionFeeActive).subscribe({
      next: (paymentResponse: InitPaymentResponse) => {
        const formUrl = isApplePay ? AMERIA_FORM_APPLE_PAY : AMERIA_FORM_CREDIT_CARD;
        window.location.href = formUrl.replace(PAYMENT_ID_NAME, paymentResponse.PaymentID);
      },
      error: (error) => {
        if (error.status === 511 && error.error && error.error.message) {
          this.showSnackbar(MockupDataModel.error(DUPLICATE_MONEY_LUX_UUID_MESSAGE), SnackBarUtil.CLASSES.error);
        }else {
          const msg = this.translateService.instant('payment_execution_error');
          this.showSnackbar(MockupDataModel.error(msg), SnackBarUtil.CLASSES.error);
        }
      },
      complete: () => {
        this.isPayClicked = false;
      }
    });
  }

  private initAllCreditCards() {
    this.creditCardService.getActive().subscribe({
      next: (card: CreditCardResponse) => {
        this.creditCard = card;
      }
    });
  }

  public payWithExistingCreditCard() {
    const price = this.inputValue;
    const description: string = this.productWithUserCardId;
    const userId: bigint = this.userCard?.userId!;
    const request: InitPaymentRequest = InitPaymentRequest.initForWalletToWallet(description, Number(price), userId, this.userCard!.cardId, this.creditCard!.cardHolderId, this.moneyLuxUuid);
    this.ameriaWalletToWalletService.makeBindingPayment(request, this.isCommissionFeeActive).subscribe({
      next: (paymentResponse: WalletToWalletPaymentReceipt) => {
        this.router.navigate(['payment/receipt'], {state: {receipt: paymentResponse}}).catch();
      },
      error: () => {
        const msg = this.translateService.instant('payment_execution_error');
        this.showSnackbar(MockupDataModel.error(msg), SnackBarUtil.CLASSES.error);
        this.isPayClicked = false;
      }
    });
  }

  public payWithTelcell() {
    const price = this.inputValue;

    if (!this.isMobile) {
      this.telcellOpenPageRequest(price);
    } else {
      this.telcellOpenMobileApp(price);
    }
  }

  public payWithEasyWallet() {
    const price = this.inputValue;
    this.easywalletService.initPayment(price, this.productWithUserCardId, String(this.PAY_VALID_DAYS), this.userCard!, this.isCommissionFeeActive, this.moneyLuxUuid);
    this.isPayClicked = false;
  }

  public payWithFastshift() {
    const price = this.inputValue;
    this.fastshiftService.initPayment(price, this.productWithUserCardId, String(this.PAY_VALID_DAYS), this.userCard!, this.isCommissionFeeActive, this.moneyLuxUuid);
    this.isPayClicked = false;
  }

  private showErrorMessageUnderPriceFor5Seconds() {
    const displayFor5Seconds = 3000;
    this.errorMessage = this.translateService.instant('enter_valid_amount');
    setTimeout(() => {
      this.hideMessageUnderPrice()
    }, displayFor5Seconds);
  }

  private hideMessageUnderPrice() {
    this.errorMessage = undefined;
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBar.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data,
    });
  }

  protected getCommission() {
    return this.userCard?.commission ? this.userCard.commission : DEFAULT_COMMISSION;
  }

  showQR(cardId: bigint, event: any) {
    event.stopPropagation();

    if (!this.checkIsValidAmount()) return;

    const paymentQrCodeRequest: PaymentQrCodeRequest = {
      cardId: cardId,
      amount: Number(this.inputValue),
      isCommissionActive: this.isCommissionFeeActive
    };

    this.paymentQrCodeService.generateQRCode(paymentQrCodeRequest).subscribe({
      next: (qrCodeBlob: Blob) => {
        const qrUrl = URL.createObjectURL(qrCodeBlob);
        const dialogConfig = new MatDialogConfig();

        dialogConfig.data = {
          userCard: this.userCard,
          qrCodeUrl: qrUrl,
          amount: this.inputValue,
          isUserCardPayment: true,
          isCommissionActive: this.isCommissionFeeActive,
        };

        dialogConfig.panelClass = 'qr-dialog';
        this.dialog.open(QrGenerateComponent, dialogConfig);
      }
    })
  }

  shareLink(): void {
    if (!this.checkIsValidAmount()) return;

    const amount = this.inputValue;
    const shareUrl = this.linkUtils.getPaymentCardLink(amount, this.isCommissionFeeActive);

    navigator.clipboard.writeText(shareUrl).then(() => {
      const message = this.translateService.instant('pay_url_copy_success_alert');
      if (!this.isMobile) {
        this.showSnackbar(MockupDataModel.success(message), SnackBarUtil.CLASSES.success);
      }
      if (navigator.share) {
        navigator.share({
          title: 'Payment Link',
          url: shareUrl
        })
      }
    });
  }

  checkIsValidAmount(): boolean {
    if (!this.inputValue || this.inputValue.trim().length === 0) {
      this.showErrorMessageUnderPriceFor5Seconds();
      this.priceInputElementRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    return true;
  }

  getLogoUrl(code: string): string {
    const config = this.paymentMethodConfigs.find(m => m.code === code);
    return config?.logoUrl ?? '';
  }

  protected readonly PaymentMethod = PaymentMethod;
  protected readonly TELCELL_PLACEHOLDER = TELCELL_PLACEHOLDER;
}
